import React from "react";
import TreeItem from "@mui/lab/TreeItem";
import { CommandContextStore } from "../context/CommandContext";
import Tree from "@naisutech/react-tree";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Button, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { dropsFilesUrl } from "../Globals";
const { useState } = React;

const commandsFileNavigation =
  `${dropsFilesUrl}/commands/files.json`;

Array.prototype.contains = function (arr) {
  return arr.every((i) => {
    if (!this.includes(i)) {
      return false;
    }
    return true;
  });
};

// linear-gradient(90deg, rgba(2007,191, 154, 0.23245) -46.17%, rgba(161,139,97,0.0001) 100%)
// linear-gradient(335.56deg, #25222A -34.07%, #27522D 184.16%)
const myThemes = {
  modifiedSygnia: {
    text: "#E3E3E3", // text color
    bg: "#000000", // background color of whole tree
    indicator: "#C3B490", // open folder indicator color
    separator: "#3B3A40", // row seperator color
    icon: "#FFFFFF", // fill & stroke color of default icons - has no effect when using custom icons
    selectedBg:
      "linear-gradient(90deg, rgba(2007,191, 154, 0.23245) -46.17%, rgba(161,139,97,0.0001) 100%)", // background of selected element
    selectedText: "#C3B490", // text color of selected element
    hoverBg: "#505a63", // background of hovered element
    hoverText: "#E3E3E3", // text color of hovered element
    accentBg: "#2d3439", // background of empty folder element
    accentText: "#999", // text color of empty folder element
    textSize: "12px", // preferred text size
  },
};

const IconRender = (label) => {
  return label === "leaf | node" ? (
    <></>
  ) : (
    <ExpandMoreIcon animate="{{ rotate: isOpen ? 90 : 0 }}" />
  );
  // if (label === 'node') { return <ExpandMoreIcon animate="{{ rotate: isOpen ? 90 : 0 }}" /> }
};

const NodeRenderer = ({ data, isOpen, isRoot, selected, level }) => {
  let padding = (level + 1) * 0.4;
  let styled = { borderTop: "1px solid #3B3A40", height: "5vh" };
  styled = isOpen
    ? {
        ...styled,
        borderLeft: "4px solid #C3B490",
        background:
          "linear-gradient(90deg, rgba(2007,191, 154, 0.23245) -46.17%, rgba(161,139,97,0.0001) 100%)",
      }
    : { ...styled, borderLeft: "4px solid transparent" };
  styled = isRoot ? styled : { ...styled, borderLeft: "3px solid #C3B490" };
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        alignItems: "center",
        hoverBg: "#505a63",
        paddingLeft: padding + "vw",
        ...styled,
      }}
    >
      <Typography variant="toolsNavigation">{data.label}</Typography>
      <IconButton size="large" style={{ color: "#C3B490" }}>
        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </IconButton>
    </div>
  );
};

const LeafRenderer = ({ data, selected, level }) => {
  let padding = (level + 1) * 0.8;
  let styled = {
    borderTop: "1px solid #3B3A40",
    background: "#25232B",
    height: "5vh",
    alignItems: "center",
  };
  styled = selected ? { ...styled, color: "#C3B490" } : styled;
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "row",
        ...styled,
        borderLeft: "3px solid #C3B490",
        hoverBg: "#505a63",
        paddingLeft: padding + "vw",
        flexGrow: true,
      }}
    >
      <Typography variant="toolsNavigation">{data.label}</Typography>
    </div>
  );
};

export const ToolsNavigation = () => {
  const [arrayOfFiles, setArrayOfFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const commandContext = React.useContext(CommandContextStore);
  const navigate = useNavigate();

  React.useEffect(() => {
    getAllFiles();
  }, []);

  React.useEffect(() => {
    filterFiles(arrayOfFiles);
  }, [commandContext.labels]);

  const changeTool = (node) => {
    let src = node[0];

    // Check this is not a folder
    if (undefined != src && src.includes(".yaml")) {
      commandContext.dispatch({ type: "UPDATE_SRC", data: src });
      navigate("/");
    }
  };

  const getAllFiles = async function () {
    // Get file structure of documented commands
    await fetch(commandsFileNavigation)
      .then((resp) => resp.json())
      .then((data) => {
        setArrayOfFiles(data);
        filterFiles(data);
      });
  };

  const filterFiles = (data) => {
    const filtered = data.map((element) => {
      // return {...element, items: element.items.filter((subElement) => subElement.tags.includes(commandContext.labels))}
      return {
        ...element,
        items: element.items.filter((subElement) =>
          subElement.tags.contains(commandContext.labels)
        ),
      };
    });
    setFilteredFiles(filtered);
  };

  const renderTree = (nodes) => {
    return (
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        label={nodes.name}
        // onClick={() => changeTool(nodes.path)}
      >
        {Array.isArray(nodes.children)
          ? nodes.children.map((node) => renderTree(node))
          : null}
      </TreeItem>
    );
  };

  return (
    <Tree
      nodes={filteredFiles}
      onSelect={changeTool}
      // grow={true}
      customTheme={myThemes}
      NodeRenderer={NodeRenderer}
      LeafRenderer={LeafRenderer}
      IconRenderer={IconRender}
      theme="modifiedSygnia"
      animations={true}
      containerStyle={{ padding: "0px" }}
    >
      {(controls) => {
        return (
          <Button
            style={{ color: "#ffffff" }}
            variant="text"
            onClick={() => controls.toggleOpenCloseAllNodes()}
          >
            Open/Close all nodes
          </Button>
        );
      }}
    </Tree>
  );
};
